// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34EdZ","type":"styles_type__2EZh_","choices":"styles_choices__T4A2N"};